<template>
  <transition name="confirm-modal-fade">
    <div v-if="visible" class="confirm-modal-mask" @click.self="onCancel">
      <div class="confirm-modal-panel">
        <div class="confirm-modal-title">{{ title }}</div>
        <div class="confirm-modal-content">{{ message }}</div>
        <div class="confirm-modal-actions">
          <button class="confirm-btn cancel" @click="onCancel">
            {{ cancelText }}
          </button>
          <button class="confirm-btn confirm" @click="onConfirm">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
defineProps<{
  visible: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}>();

const emit = defineEmits<{
  confirm: [];
  cancel: [];
}>();

const onConfirm = () => {
  emit("confirm");
};

const onCancel = () => {
  emit("cancel");
};
</script>

<style scoped>
.confirm-modal-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.confirm-modal-panel {
  width: 100%;
  max-width: 320px;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: confirmSlideIn 0.25s;
}

@keyframes confirmSlideIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.confirm-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  text-align: center;
  margin-bottom: 12px;
}

.confirm-modal-content {
  font-size: 15px;
  color: #666;
  text-align: center;
  line-height: 1.5;
  margin-bottom: 24px;
}

.confirm-modal-actions {
  display: flex;
  gap: 12px;
}

.confirm-btn {
  flex: 1;
  padding: 12px 0;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-btn.cancel {
  background: #f5f5f5;
  color: #666;
}

.confirm-btn.cancel:hover {
  background: #e8e8e8;
}

.confirm-btn.confirm {
  background: #007aff;
  color: #fff;
}

.confirm-btn.confirm:hover {
  background: #0056cc;
}

.confirm-modal-fade-enter-active,
.confirm-modal-fade-leave-active {
  transition: opacity 0.2s;
}

.confirm-modal-fade-enter-from,
.confirm-modal-fade-leave-to {
  opacity: 0;
}
</style>
